import { GS3HeaderLogo } from "@/assets/images";
import { useUserContext } from "@shared/contexts";
import { usePatchUserPreferencesMutation } from "@shared/api/server/gs3Server";
import { setThemePreference, useDarkMode } from "@shared/hooks";
import { useLanguageProfileMenuActions, useLocalization } from "@i18n";
import { Avatar, Header as HederBase } from "@telluscompany/design-system";
import { LogOut, Sun } from "lucide-react";

const getInitials = (name?: string) => {
  if (!name) return "GA";
  const parts = name.trim().split(" ");
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const Header = () => {
  const { translate } = useLocalization();
  const { user, logout } = useUserContext();
  const [isDark] = useDarkMode();
  const { mutateAsync } = usePatchUserPreferencesMutation();
  const languageActions = useLanguageProfileMenuActions();

  const toggleTheme = () => {
    const stored = localStorage.getItem("theme");
    const previous = stored === "light" || stored === "dark" ? stored : null;
    const next = isDark ? "light" : "dark";
    setThemePreference(next);
    void mutateAsync({ theme: next }).catch(() => {
      setThemePreference(previous);
    });
  };

  return (
    <div>
      <HederBase
        avatar={
          <Avatar
            badge={false}
            shape="circular"
            size="lg"
            text={getInitials(user?.name)}
            variant="text"
          />
        }
        logo={<img src={GS3HeaderLogo} alt="GS3 Header Logo" />}
        menu={[
          {
            actions: [
              ...languageActions,
              {
                icon: <Sun size={16} />,
                label: translate("common.toggleTheme"),
                onClick: toggleTheme,
              },
              {
                icon: <LogOut size={16} />,
                label: translate("auth.logout"),
                onClick: async () => await logout(),
                colorTitle: "red",
              },
            ],
          },
        ]}
      />
    </div>
  );
};
